export default __webpack_public_path__ + "static/IBMPlexSans-SemiBold-Greek-087790ae4a29d53d16b60cc330f828b3.woff";